import Vue from 'vue';
import ProductSku from '../../../stores/schema/ProductSku';

//
// Shipping Info
// ---------------------------------------------
export default Vue.extend({
  props: [
    'sku',
    'isLoading',
    'warehouseLocation'
  ],
  computed: {
    shippingAllowedCountryNames() {
      if (this.sku.shipping_allowed_country_names && (this.sku.shipping_allowed_country_names.length > 0)) {
        return this.sku.shipping_allowed_country_names.join(', ');
      }
      return '';
    },
    shippedDeniedCountryNames() {
      if (this.sku.shipped_denied_country_names && (this.sku.shipped_denied_country_names.length > 0)) {
        return this.sku.shipped_denied_country_names.join(', ');
      }
      return '';
    },
    displayExtraWeeks() {
      return ProductSku.getExpectedShipAtOrExtraWeek(this.sku);
    },
    isBto() {
      return ProductSku.isBto(this.sku);
    },
    isPreOrder() {
      return ProductSku.isPreOrder(this.sku);
    },

    // TOMバルク船便候補商品かつ在庫ある商品の場合
    isCanBulkShippingAndStock() {
      return ProductSku.isCanBulkShippingAndStock(this.sku, window.tom.conf.access_country_code);
    },

    isBeforeExpectedShipAt() {
      return ProductSku.isBeforeExpectedShipAt(this.sku);
    },

    inStockExpectedShipDays() {
      return ProductSku.inStockExpectedShipDays(this.sku);
    }
  }
});
